import { render, staticRenderFns } from "./homeType.vue?vue&type=template&id=60a0a41f&scoped=true&"
import script from "./homeType.vue?vue&type=script&lang=js&"
export * from "./homeType.vue?vue&type=script&lang=js&"
import style0 from "./homeType.vue?vue&type=style&index=0&id=60a0a41f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0a41f",
  null
  
)

/* custom blocks */
import block0 from "./homeType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports